import axios from 'axios';

// keep in url for now
const api = axios.create({
  baseURL: 'https://api-magu.herokuapp.com',
});

export default api;
